import React from 'react';

const ButtonIconQuickAction = ({ children, onClick, disabled = false }) => {
    const classes = ['appButton__iconQuickAction'];
    if (disabled) {
        classes.push('appButton__iconQuickAction--disabled');
    }

    return(
        <button type="button" className={classes.join(' ')} onClick={onClick} disabled={disabled}>
            {children}
        </button>
    )
}

export default ButtonIconQuickAction;